import { Spin, SpinProps } from 'antd';

export default (props: SpinProps) => {
  return <Spin {...props} />;
};
